export const PAYMENT_METHODS = {
  checkout: 1,
  idex: 2,
  tpay: 3,
  tamatem: 4,
  // inapp: 5, // not supported
  free: 6,
  paymob: 7,
} as const

export const SUP_PAYMENT_METHODS = {
  card: 1,
  googlePay: 2,
  applePay: 3,
  stcPay: 4,
  paypal: 5,
  mobily: 6,
  telecom_egypt_we: 7,
  etisalat_egypt: 8,
  orange_egypt: 9,
  orange_jordan: 10,
  umniah_jordan: 11,
  apple_in_app_purchases: 22,
  google_in_app_purchases: 23,
  free: 24,
  paymob_card: 25,
  paymob_wallet: 26,
} as const

export const SUBSCRIPTION_STATUS = {
  active: 1,
  pending: 2,
  cancelled: 3,
  expired: 4,
  unpaid: 5,
}
